module.exports = __webpack_public_path__ + "img/svg/multiplayer-competition-card-hover.ead1f5868c318b64403d961bb79d0dd3.svg";